import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import { Provider } from 'mobx-react';
import { MuiThemeProvider } from 'material-ui/styles';
import { HashRouter as Router } from 'react-router-dom';

import Theme from './theme';
import stores from './stores';
import Auth from './psuite-js/helpers/auth';

if (!Auth.redirectIfHasNoToken()) {
    ReactDOM.render(
        <Provider {...stores} >
            <Router>
                <MuiThemeProvider theme={Theme}>
                    <App />
                </MuiThemeProvider>
            </Router>
        </Provider>
        , document.getElementById('root')
    );
}



// WEBPACK FOOTER //
// ./src/index.js